import { ProductPurchaseOption, ProductPurchaseType } from '../productMap';
import { NewM1Data } from './IN';

export const m1data: Record<
  string,
  Array<Record<string, string | HTMLImageElement | number>> | boolean
> = {
  taxInclusive: false,
  plans: [
    {
      displayName: 'Ultrahuman M1 Live | 1 Month continuous glucose monitoring',
      price: 189,
      variantId: 'gid://shopify/ProductVariant/49202716934462',
      internalPid: 'otp_4_weeks_eu',
      secondaryImage: '',
    },
    {
      displayName:
        'Ultrahuman M1 Live | 3 Months continuous glucose monitoring',
      price: 539,
      variantId: 'gid://shopify/ProductVariant/49202716999998',
      internalPid: 'otp_12_weeks_eu',
      secondaryImage: '',
    },
  ],
};

export const M1_Switzerland: NewM1Data = {
  [ProductPurchaseOption.oneTimePurchase]: {
    title: 'One Time Purchase',
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
    directCheckout: true,
    plans: {
      [ProductPurchaseType.otp_4_weeks_eu]: {
        displayName:
          'Ultrahuman M1 Live | 1 Month continuous glucose monitoring',
        price: 249,
        variantId: 'gid://shopify/ProductVariant/49202716934462',
        internalPid: ProductPurchaseType.otp_4_weeks_eu,
        secondaryImage: '',
        title: '4 Weeks',
        subtitle1: '2 CGM Sensors',
        subtitle2: 'Delivery on purchase',
        checkoutUrl: 'https://buy.stripe.com/4gw02Y5aJ1M88Eg28f',
      },
    },
  },
};

export const M1_Iceland: NewM1Data = {
  [ProductPurchaseOption.oneTimePurchase]: {
    title: 'One Time Purchase',
    defaultProduct: ProductPurchaseType.otp_2_weeks_eu,
    directCheckout: true,
    plans: {
      [ProductPurchaseType.otp_2_weeks_eu]: {
        displayName:
          'Ultrahuman M1 Live | 2 weeks continuous glucose monitoring',
        price: 175,
        variantId: 'gid://shopify/ProductVariant/49203361284414',
        internalPid: ProductPurchaseType.otp_2_weeks_eu,
        secondaryImage: '',
        title: '2 Weeks',
        subtitle1: '1 CGM Sensors',
        subtitle2: 'Delivery on purchase',
        checkoutUrl: 'https://buy.stripe.com/dR6dTO32B3Ugg6IbIO',
      },
    },
  },
};

export const M1_Euro: NewM1Data = {
  [ProductPurchaseOption.oneTimePurchase]: {
    title: 'One Time Purchase',
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
    directCheckout: false,
    plans: {
      [ProductPurchaseType.otp_4_weeks_eu]: {
        displayName:
          'Ultrahuman M1 Live | 1 Months continuous glucose monitoring',
        price: 189,
        variantId: 'gid://shopify/ProductVariant/49202716934462',
        internalPid: ProductPurchaseType.otp_4_weeks_eu,
        secondaryImage: '',
        title: '4 weeks',
        subtitle1: '2 CGM Sensors',
        subtitle2: 'Delivery on purchase',
      },
    },
  },
};

export const NON_MCF_M1_Euro: NewM1Data = {
  [ProductPurchaseOption.oneTimePurchase]: {
    title: 'One Time Purchase',
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
    directCheckout: true,
    plans: {
      [ProductPurchaseType.otp_4_weeks_eu]: {
        displayName:
          'Ultrahuman M1 Live | 1 Month continuous glucose monitoring',
        price: 189,
        variantId: 'gid://shopify/ProductVariant/49202716934462',
        internalPid: ProductPurchaseType.otp_4_weeks_eu,
        secondaryImage: '',
        title: '4 Weeks',
        subtitle1: '2 CGM Sensors',
        subtitle2: 'Delivery on purchase',
        checkoutUrl: 'https://buy.stripe.com/28obLG32B9eA3jW7sx',
      },
    },
  },
};
